import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CommonServiceService } from 'src/app/pages/services/common-service.service';
import { ContentService } from 'src/app/shared/services/content.service';

@Component({
  selector: 'app-form-list',
  templateUrl: './form-list.component.html',
  styleUrls: ['./form-list.component.scss']
})
export class FormListComponent implements OnInit {

  constructor(
    private commonService: CommonServiceService,
    private contentService: ContentService,
    public router: Router,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(params => {
      this.urlData = params;
      sessionStorage.setItem('ipsaListingPrams', JSON.stringify(this.urlData));
    });
  }
  formId: any;
  apiUrl = '';
  noDataFound = false;
  jwtToken: any;
  sectionCardId: any;
  resourceHead: any;
  showFormName: any;
  userData: any = JSON.parse(sessionStorage.getItem('userdata') || '{}');
  countryDetails: any;
  showAddNewForm = false;
  urlParams: {formId: number} = {
    formId : 1
  };
  formListingData: any[] = [];
  totalDataCount = 0;
  public limit = 10;
  public skip = 0;
  public page = 0;
  countryData: any = [];
  viewForm = true;
  formName = '';
  allowedAction: any = [];
  baseFormModule: string[] = ['ipsa'];
  downloadResponse: any = [];
  formListData: any = [];
  improvementFormListData: any = [];
  formListOriginalData: any = [];
  urlData: any;
  sectors: any = [];
  msmes: any = [];
  classifications: any = [];

  resourceCenter: any = [
    {
      label : 'S.No.'
    },
    {
      label : 'Date Of Submission'
    },
    {
      label : 'Action'
    },

  ];

  ngOnInit(): void {
    this.contentService.loaderSubscriber.next(true);
    this.jwtToken = sessionStorage.getItem('jwtToken') || '';
    this.commonService.formGetMethod('sector/list').subscribe((res: any) => {
      if (res && res.data && res.data.length) {
        this.sectors = res.data;
      }
    });
    this.commonService.formGetMethod('msme/list').subscribe((res: any) => {
      if (res && res.data && res.data.length) {
        this.msmes = res.data;
      }
    });
    this.commonService.formGetMethod('msme-classification/list').subscribe((res: any) => {
      if (res && res.data && res.data.length) {
        this.classifications = res.data;
      }
      this.getFormsList();
    }, () => {
      // Still proceed; classification is optional for showing the list
      this.classifications = [];
      this.getFormsList();
    });
  }

  getCellValue(row: any, key: string): string {
    const val = row?.data && key != null ? row.data[key] : undefined;
    return val != null && val !== '' ? val : '--';
  }

  findClassification(employeeCount: number): string | null {
    if (employeeCount == null) { return null; }

    const classification = this.classifications.find(
      (entry: any) =>
        entry.min_employee_count <= employeeCount &&
        entry.max_employee_count >= employeeCount
    );

    return classification ? classification.type : null;
  }

  getFormsList(): void {
    const payload = {
        // Projection keeps Form.io from serialising every form's `components` tree
        // (~16MB / ~30s for the full list). Listing only needs the metadata below;
        // component definitions are fetched on demand via /form/{id}.
        endpoint: '/form?limit=50&select=_id,title,name,path,type,display,tags,modified',
        headers: {
            'Content-Type': 'application/json',
            'x-jwt-token': this.jwtToken
        },
        method: 'GET'
    };
    this.commonService.getAllFormList(payload).subscribe(res => {
      if (res){
        if (res.length && res[0].hasOwnProperty('x-jwt-token')) {
        sessionStorage.setItem('jwtToken', res[0]['x-jwt-token']);
        }

        this.showFormName = this.urlData?.formName;
        if (this.userData?.userlevel_id !== 1) {
          let classification: string | null = null;
          if (this.classifications.length) {
            classification = this.findClassification(this.userData.employeeCount);
          }

          const classificationPart = (classification && classification.toLowerCase()) || '';

          this.formName = (this.showFormName || '').replaceAll(' ', '').toLowerCase() + classificationPart;
          this.formListData = res.filter((ele: any) => ele.path && ele.path.toString() === this.formName.toString());
          this.improvementFormListData = res.filter((ele: any) => ele.path && ele.path.toString() === this.formName.toString().replace('assessment', 'improvement'));
        } else {
          const formName = this.showFormName.toLowerCase().replaceAll(' ', '');
          this.formListData = res.filter((ele: any) => ele.path && ele.path.toString().includes(formName) && !ele.path.toString().includes('improvement'));
          this.improvementFormListData = res.filter((ele: any) => ele.path && ele.path.toString().includes(formName.replace('assessment', 'improvement')));
        }


        this.formListOriginalData = res;

        this.getDataFormList();
      }
    });
  }

  getDataFormList(): void {
    this.contentService.loaderSubscriber.next(true);
    const requests = this.formListData.map((data: any) => {
      const endpoint = `/${data.path}/submission`;
      const payload = { endpoint, headers: {
        'Content-Type': 'application/json',
        'X-jwt-token': this.jwtToken
      }, requestBody: {}, method: 'GET' };
      return this.commonService.prefillFormIO(payload);
    });

    forkJoin(requests).subscribe({
      next: (responses: any[]) => {
        this.formListingData = [];
        this.totalDataCount = 0;

        const list: any = [];
        responses.forEach((res: any, idx: number) => {
          const formPath = this.formListData?.[idx]?.path;
          if (res && Array.isArray(res) && res.length && res[0].hasOwnProperty('x-jwt-token')) {
            sessionStorage.setItem('jwtToken', res[0]['x-jwt-token']);
          }

          if (res && Array.isArray(res)) {
            for (const item of res) {
              const sector = this.sectors.find((s: any) => s.id === item.data.sector);
              const msme   = this.msmes.find((s: any) => s.id === item.data.msme);

              item.sectorName = sector ? sector.name : '';
              item.msmeName   = msme ? msme.name   : '';
              item.formPath = formPath;
              list.push(item);
            }
          }
        });

        this.formListingData = list;
        this.totalDataCount = list.length;
        this.page = 0;
        this.skip = 0;

        this.noDataFound = this.formListingData.length === 0;
        this.showAddNewForm = this.formListingData.length === 0 && this.userData?.userlevel_id !== 1;

        const submissionRequests = this.improvementFormListData.map((data: any) => {
          const submissionEndpoint = `/${data.path}/submission`;
          const submissionPayload = { endpoint: submissionEndpoint, headers: {
            'Content-Type': 'application/json',
            'X-jwt-token': this.jwtToken
          }, requestBody: {}, method: 'GET' };
          return this.commonService.prefillFormIO(submissionPayload);
        });

        const submissions$ = submissionRequests.length ? forkJoin(submissionRequests) : of([]);
        submissions$
          .pipe(finalize(() => this.contentService.loaderSubscriber.next(false)))
          .subscribe({
            next: (submissionResponses: any[]) => {
              submissionResponses.forEach((res: any) => {
                if (res && Array.isArray(res) && res.length && res[0].hasOwnProperty('x-jwt-token')) {
                  sessionStorage.setItem('jwtToken', res[0]['x-jwt-token']);
                }

                if (res && Array.isArray(res)) {
                  for (const item of res) {
                    const formDataIndex = this.formListingData.findIndex(
                      (formData: any) => formData.owner.toString() === item.owner.toString()
                    );
                    if (formDataIndex >= 0) {
                      this.formListingData[formDataIndex].submissionId = item._id;
                    }
                  }
                }
              });
            },
            error: () => {
              // Loader is hidden by finalize()
            }
          });
      },
      error: () => {
        this.formListingData = [];
        this.totalDataCount = 0;
        this.noDataFound = true;
        this.contentService.loaderSubscriber.next(false);
      }
    });




    if (!this.formListingData.length && this.userData?.userlevel_id !== 1) {
      this.showAddNewForm = true;
    }

    if (this.userData?.userlevel_id === 1) {
      this.showAddNewForm = false;
    }
  }

  openImprovementPlan(row: any): void {
    const basePath = row?.formPath || '';
    const improvementPath = basePath.replace('assessment', 'improvement');
    if (!improvementPath) { return; }

    const form = this.formListOriginalData.find((item: any) => item.path === improvementPath);
    const currentForm = this.formListOriginalData.find((item: any) => item.path === basePath);

    const queryParams: any = {
      formName: currentForm && currentForm.title ? currentForm.title : '',
      formId: form && form._id ? form._id.toString() : '',
      assessmentSubmissionId: row?._id ? row._id.toString() : ''
    };
    if (row?.submissionId) {
      queryParams.submissionId = row.submissionId.toString();
    }
    if (this.userData?.userlevel_id === 1) {
      queryParams.editMode = 'viewMode';
    }

    this.router.navigate(['prism-forms-design'], {
      queryParams
    });
  }

  backToForm(): void {
    this.router.navigate(['/prism-forms']);
  }
  backToIpsa(): void {
    this.router.navigate(['/prism']);
  }
  setPage(event: any): void {
    if (this.limit !== event.pageSize) {
      this.limit = event.pageSize;
      this.page = 0;
    } else {
      this.page = event.pageIndex;
    }
    this.skip = this.page * this.limit;
  }

  editForm(editMode: string = 'editMode', data: any): void {
    const id = data?.form;
    const effectiveEditMode = this.userData?.userlevel_id === 1 ? 'viewMode' : editMode;
    this.commonService.updatePrefillIpsa(data);
    this.router.navigate(['prism-forms-design'], {queryParams: {
      formName: this.urlData?.formName,
      formId: id,
      editMode: effectiveEditMode,
      isDraft: data?.isDraft,
      submissionId: data._id.toString()
    }});

  }

   downloadCSV(): void {
    const currentBaseUrl = '';
    const format = 'csv';

    this.commonService.downloadDashboardCSV(currentBaseUrl, format).subscribe((res: any) => {
      this.downloadResponse = res;
      this.commonService.downloadCSVFile(this.downloadResponse, this.formName);

    });
  }

  viewFormStructure(selectedCardID: any): void {
    this.sectionCardId = selectedCardID;
    const selectedCard = this.formListData.find((ele: any) => ele._id === selectedCardID);
    this.commonService.formComponentData.next(selectedCard.components);

    const queryParams: any = {
      formName: this.urlData?.formName,
      formId: selectedCardID
    };
    if (this.userData?.userlevel_id === 1) {
      queryParams.editMode = 'viewMode';
    }

    this.router.navigate(['prism-forms-design'], { queryParams });
  }

  extractInputFields(jsonObj: any): any[] {
    const inputFields: any = [];

    // Recursive function to traverse the JSON object
    const traverse = (obj: any): void => {
        // Check if obj is an array
        if (Array.isArray(obj)) {
            obj.forEach(item => traverse(item));
        } else if (typeof obj === 'object') {
            // Check if the current object has an "input" key set to true
            if (obj.input === true && obj.key.indexOf('uploadAvailableDocuments') < 0 ) {
              const label = obj.label.replace(/[0-9.]/g, '');
              inputFields.push({ label, key: obj.key });
            }
            // Traverse each property of the object
            Object.keys(obj).forEach(key => traverse(obj[key]));
        }
    };

    traverse(jsonObj);
    return inputFields;
  }

}


